/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/web.timers.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tab from "vux/src/components/tab/tab.vue";
import TabItem from "vux/src/components/tab/tab-item.vue";
import Swiper from "vux/src/components/swiper/swiper.vue";
import SwiperItem from "vux/src/components/swiper/swiper-item.vue";
import BScroll from "better-scroll";
import { GetScienceArticleList } from '@/api';
import cryIcon from "@/resources/images/icons/icon_cry.png";
import CopyRight from 'CopyRight';
import NoData from '@/components/NoData';
import ListItem from '@/components/ListItem';
export default {
  data: function data() {
    return {
      curPage: 0,
      isShowDetail: false,
      categoryList: [],
      articleList: [],
      empty: false
    };
  },
  created: function created() {
    this.curPage = Utils.getUrlByParam('turnPage') ? Utils.getUrlByParam('turnPage') : 0;

    if (history.state) {
      history.state.curPage = 0;
    }

    this.getScienceArticleListAjax();
  },
  watch: {
    curPage: function curPage() {}
  },
  components: {
    Tab: Tab,
    TabItem: TabItem,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    CopyRight: CopyRight,
    NoData: NoData,
    ListItem: ListItem
  },
  mounted: function mounted() {},
  computed: {},
  methods: {
    linkToArticle: function linkToArticle(url) {
      if (url) {
        console.log(url);
        url = url.indexOf('#') > -1 ? url.substring(0, url.indexOf('#')) : url;
        console.log(url);
        window.location.href = url;
      }
    },

    /**
     * 获取科普文章列表 getScienceArticleListAjax
     */
    getScienceArticleListAjax: function getScienceArticleListAjax() {
      var _this = this;

      GetScienceArticleList().then(function (data) {
        var articleList = data.articleList.dataSource;
        var location = 0;
        articleList.forEach(function (v, index, array) {
          v.IMAGE_URL = v.IMAGE_URL && '' != v.IMAGE_URL ? v.IMAGE_URL : cryIcon;
        });

        if (articleList.length <= 0) {
          _this.empty = true;
        } else {
          _this.empty = false;
        }

        for (var index in articleList) {
          //对没有分类的文章统一归纳为其他
          if (!articleList[index].LABLE_NAME) {
            articleList[index].LABLE_NAME = "其他";
          } //时间格式转换


          articleList[index].ADD_DATE = Utils.gettimeFormat("yyyy-MM-dd hh:mm:ss", articleList[index].ADD_DATE);
          location = _this.categoryList.findIndex(function (value) {
            return value === articleList[index].LABLE_NAME;
          }); // 科普文章分类

          if (-1 == location) {
            _this.categoryList.push(articleList[index].LABLE_NAME);

            var newCategoryList = [];
            newCategoryList.push(articleList[index]);

            _this.articleList.push(newCategoryList);
          } else {
            _this.articleList[location].push(articleList[index]);
          }
        }

        _this.$nextTick(function () {
          //给每一个分类添加滚动条
          _this.categoryList.forEach(function (v, i, array) {
            _this["myScroll" + i] = new BScroll('#' + _this.categoryList[i], {
              useTransform: true,
              scrollbars: true,
              click: true,
              disableMouse: true,
              disablePointer: true
            });
            setTimeout(function () {
              _this["myScroll" + i].refresh();
            }, 10);
          });
        });
      });
    }
  }
};